import { IconShieldX, IconUsers } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Card, CardDescription, CardHeader, CardTitle } from '~/components/ui/card'
import { useSessionStore } from '~/stores/session'

const adminModules = [
  {
    titleKey: 'sidebar.ngWords',
    descriptionKey: 'ngWords.title',
    icon: IconShieldX,
    url: '/ng-words',
  },
  // HER-311: Category Applications, Category Requests, and Service Packages
  // cards removed — those admin pages are disabled (routes + sidebar entries
  // removed in app.tsx / nav-main.tsx).
  {
    titleKey: 'sidebar.userManagement.users',
    descriptionKey: 'users.title',
    icon: IconUsers,
    url: '/users',
  },
]

export function HomePage() {
  const { t } = useTranslation()
  const user = useSessionStore((state) => state.user)

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold" id="home-title">
          {t('home.greeting', { name: user?.username || user?.email || 'Admin' })}
        </h1>
        <p className="mt-1 text-muted-foreground">{t('home.subtitle')}</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {adminModules.map((module) => (
          <Link key={module.url} to={module.url}>
            <Card className="transition-colors hover:border-primary hover:bg-accent">
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary/10 text-primary">
                    <module.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <CardTitle className="text-base">{t(module.titleKey)}</CardTitle>
                    <CardDescription>{t(module.descriptionKey)}</CardDescription>
                  </div>
                </div>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  )
}
